//OffscreenCanvas Polyfill, mainly for Safari
if (typeof window.OffscreenCanvas === 'undefined') {
  window.OffscreenCanvas = class OffscreenCanvas {
    constructor(width:number, height:number) {
      this.canvas = document.createElement("canvas");
      this.canvas.width = width;
      this.canvas.height = height;

      this.canvas.convertToBlob = () => {
        return new Promise(resolve => {
          this.canvas.toBlob(resolve);
        });
      };

      return this.canvas;
    }
  };
}